export default __webpack_public_path__ + "static/media/pgmico(16).01307123.png";